import { motion } from "framer-motion";

export default function SystemSection() {
  return (
    <section id="system" className="relative w-full py-20 md:py-32 bg-warm-900">
      <div className="max-w-[1000px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-10 md:mb-14"
        >
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-4">
            SYSTEM
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-50">
            料金システム
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="space-y-12"
        >
          {/* 飲み放題 */}
          <div>
            <p className="text-center text-base font-sans font-medium text-warm-300 mb-3">飲み放題</p>
            <div className="border-t border-warm-700 pt-6 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="text-center border border-warm-700 rounded-xl py-6 px-4">
                  <p className="text-base md:text-lg font-sans font-bold text-warm-200 mb-3">OPEN〜23:59</p>
                  <p className="font-heading text-3xl md:text-4xl font-bold text-amber-500">
                    2,000円<span className="text-base font-sans font-normal text-warm-400 ml-1">（1h）</span>
                  </p>
                  <p className="text-base md:text-lg font-sans text-warm-300 mt-2">
                    延長（1h）<span className="font-bold ml-2">1,500円</span>
                  </p>
                </div>
                <div className="text-center border border-warm-700 rounded-xl py-6 px-4">
                  <p className="text-base md:text-lg font-sans font-bold text-warm-200 mb-3">24:00〜翌6:00</p>
                  <p className="font-heading text-3xl md:text-4xl font-bold text-amber-500">
                    2,000円<span className="text-base font-sans font-normal text-warm-400 ml-1">（1h）</span>
                  </p>
                  <p className="text-base md:text-lg font-sans text-warm-300 mt-2">
                    延長（1h）<span className="font-bold ml-2">1,000円</span>
                  </p>
                </div>
              </div>
              <p className="text-sm font-sans text-warm-400 text-center">
                飲み放題のラストオーダーは終了時間の<span className="font-bold text-warm-200">15分前</span>
              </p>
            </div>
          </div>

          {/* ボトル */}
          <div>
            <p className="text-center text-base font-sans font-medium text-warm-300 mb-3">ボトル</p>
            <div className="border-t border-warm-700 pt-6">
              <div className="text-center space-y-3">
                <p className="text-base md:text-lg font-sans text-warm-300">
                  チャージ料金　<span className="font-bold text-warm-100">1,000円</span><span className="text-sm text-warm-500 ml-1">（2h）</span>
                </p>
                <p className="text-base md:text-lg font-sans text-warm-300">
                  延長料金　<span className="font-bold text-warm-100">1,000円</span><span className="text-sm text-warm-500 ml-1">（1h）</span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
